import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import TextField from '@mui/material/TextField'
import Chip from '@mui/material/Chip'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import $, { post } from 'jquery'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { saveAs } from 'file-saver' // For downloading files
import JSZip from 'jszip' // Library for working with zip files
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useCallback, useEffect, useState } from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import DropBox from '../../custom/DropBox'
import AWS from 'aws-sdk'
import ShowImage from '../../custom/ShowImage'
import { showDangerToast, showToast } from '../../constants/toaster'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { useDispatch, useSelector } from 'react-redux'
import { uplodateLoading } from '../../../redux/features/common/commonSlice'
import { pull } from 'lodash'
import { s3 } from '../../constants/awsConfig'
const imageFileTypes = ['image/png', 'image/gif', 'image/jpeg']
const otherFileTypes = ['.arscene', '.videofx']

export const AddSticker = props => {
  const [inputValue, setInputValue] = useState('')
  const dispatch = useDispatch()

  const handleInputChangeTag = event => {
    setInputValue(event.target.value)
  }

  const handleInputKeyDown = event => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      props?.setTags([...props?.tags, inputValue.trim()])
      setInputValue('')
    }
  }

  const handleChipDelete = tagToDelete => () => {
    props?.setTags(prevTags => prevTags.filter(tag => tag !== tagToDelete))
  }
  const [value, setValue] = useState(dayjs())
  const [images, setImages] = useState([])
  const [files, setFiles] = useState([])
  const [startDate, setStartDate] = useState(new Date('2023-10-16T06:23:56'))
  const [endDate, setEndDate] = useState()
  const [startDateChanged, setStartDateChanged] = useState(false)
  const userData = useSelector(state => state?.userData)
  const [meisheAssetFile, setMeisheAssetFile] = useState(null)
  const [bannerFile, setBannerFile] = useState(null)
  const [assetInfoJson, setAssetInfoJson] = useState(null)
  const [mp4File, setMp4File] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const [isSubmitted, setIsSubmitted] = useState(false);

  const uploadFile = async assetFile => {
    if (!assetFile) return;

    const params = {
      Bucket: 'praxo-dev-cloud-front', // bucket name
      Key: `uploads/${assetFile.name}`,
      Body: assetFile,
      ContentType: assetFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      console.log('Upload Success', data.Location);
      const url = data.Location.replace(
        "https://praxo-dev-cloud-front.s3.ap-south-1.amazonaws.com/",
        "https://dhwdwg726vpm7.cloudfront.net/"
      );
      console.log(url, 'url');
      return url
    } catch (error) {
      console.error('Error uploading file:', error);
      return ''
    }
  }

  // const handleOnFileSelect = async event => {
  //   let validationDone = false
  //   const file = event.target.files[0]
  //   if (
  //     file &&
  //     (file.type === 'application/zip' ||
  //       file.type === 'application/x-zip-compressed')
  //   ) {
  //     setMeisheAssetFile(file)
  //     const zip = await JSZip.loadAsync(file)
  //     const zipFileNameWithoutExt = file.name.replace(/\.[^/.]+$/, ''); // Remove .zip extension
  //     let hasMatchingMp4 = false;
  //     let mp4FileObject = null;
  //     console.log(zip)
  //     const promises = [];
  //     zip.forEach(async (relativePath, zipEntry) => {
  //       if (relativePath === `${zipFileNameWithoutExt}/info.json`) {
  //         const fileData = await zip.file(`${zipFileNameWithoutExt}/info.json`).async('text') // Read the content as text
  //         console.log(fileData)
  //         let postData = JSON.parse(fileData)
  //         setAssetInfoJson(postData)
  //       }
  //       // Check if the ZIP contains an .mp4 file with the same name as the ZIP file
  //       if (relativePath === `${zipFileNameWithoutExt}/cover.mp4`) {
  //         hasMatchingMp4 = true;
  //         promises.push(
  //           zip.file(relativePath).async('blob').then((blob) => {
  //             mp4FileObject = new File([blob], `${zipFileNameWithoutExt}.mp4`, {
  //               type: 'video/mp4',
  //             });
  //           })
  //         );
  //       }
  //     })
  //     await Promise.all(promises); // Ensure all async operations complete

  //     if (!hasMatchingMp4) {
  //       showDangerToast(`MP4 file named "${zipFileNameWithoutExt}.mp4" is missing in the ZIP.`);
  //     } else {
  //       setMp4File(mp4FileObject); // Store MP4 file object for upload
  //     }
  //   } else {
  //     showDangerToast('Please select a zip file.')
  //   }
  // }


  const handleOnFileSelect = async (event) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type === 'application/zip' || file.type === 'application/x-zip-compressed')
    ) {
      setMeisheAssetFile(file);
      const zip = await JSZip.loadAsync(file);
      const zipFileNameWithoutExt = file.name.replace(/\.[^/.]+$/, ''); // Extract filename without .zip extension
      const filename = zipFileNameWithoutExt?.split('.')[0];
      let hasMatchingMp4 = false;
      let mp4FileObject = null;

      const promises = [];
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
      let hasMatchingImage = false;
      let imageFileObject = null;
      // First, loop through the outer ZIP to find an inner ZIP
      zip.forEach(async (relativePath, zipEntry) => {
        if (relativePath === `${filename}.mp4`) {
          hasMatchingMp4 = true;
          mp4FileObject = new File([await zip.file(`${filename}.mp4`).async('blob')], `${filename}.mp4`, {
            type: 'video/mp4',
          });
          setMp4File(mp4FileObject); // Store MP4 file object for upload
        }
        if (imageExtensions.some(ext => relativePath.toLowerCase().endsWith(ext))) {
          if (!imageFileObject) {
            hasMatchingImage = true;
            imageFileObject = new File([await zip.file(relativePath).async('blob')], relativePath, {
              type: `image/${relativePath.split('.').pop()}`,
            });
            setImageFile(imageFileObject); // Store Image file object for upload
          }
        }
        if (relativePath === `info.json`) {
          const fileData = await zip.file(`info.json`).async('text') // Read the content as text
          console.log(fileData)
          let postData = JSON.parse(fileData)
          try {
            if (postData?.translation?.size) {
              let originalText = postData?.translation?.size?.[0]?.originalText
              postData.name = originalText;
            } else {
              let originalText = postData?.translation?.originalText
              if (originalText) {
                postData.name = originalText;
              }
            }
          } catch (err) {
            let originalText = postData?.translation?.originalText
            if (originalText) {
              postData.name = originalText;
            }
          }
          setAssetInfoJson(postData)
        }
        if (relativePath.endsWith('.zip') && relativePath !== file.name) {
          // Found an inner ZIP, extract and process it
          promises.push(
            zip.file(relativePath).async('blob').then(async (innerZipBlob) => {
              const innerZip = await JSZip.loadAsync(innerZipBlob);

              innerZip.forEach(async (innerPath, innerEntry) => {
                if (innerPath.endsWith('.mp4')) {
                  hasMatchingMp4 = true;
                  mp4FileObject = new File([await innerZip.file(innerPath).async('blob')], innerPath, {
                    type: 'video/mp4',
                  });
                }
                console.log('Inner ZIP File:', innerPath);
              });
            })
          );
        } else {
          console.log("asd")
        }
      });
    } else {
      showDangerToast('Please select a zip file.');
    }
  };





  const handleOnFileBannerSelect = async event => {
    const file = event.target.files[0]
    if (file) {
      setImageFile(file)
    } else {
      showDangerToast('Please select a image file.')
    }
  }

  const callAPI = async postData => {
    // call API HERE
    try {
      let path = urls.addMeisheAssets
      var resBlog = await ApiCaller.post(postData, path, userData?.access_token)
      const responseBlog = await resBlog.response.json()
      if (responseBlog.status == 200) {
        dispatch(uplodateLoading(false))
        showToast(responseBlog?.message)
        props?.onHide()
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(responseBlog.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleSubmit = async () => {
    setIsSubmitted(true)
    if (meisheAssetFile && imageFile) {
      dispatch(uplodateLoading(true))
      let previewUrl = '';
      let bannerImage = '';
      if (mp4File) {
        previewUrl = await uploadFile(mp4File)
      }
      if (imageFile) {
        bannerImage = await uploadFile(imageFile)
      }
      let postData
      try {
        const zip = await JSZip.loadAsync(meisheAssetFile)
        zip.forEach(async (relativePath, zipEntry) => {
          console.log(zipEntry)
          if (relativePath === 'info.json') {
            const fileData = await zip.file('info.json').async('text') // Read the content as text
            console.log(fileData)
            postData = JSON.parse(fileData)
            const responseImage = await uploadFile(meisheAssetFile)
            if (!responseImage) {
              alert("Something went wrong while upload zip file.")
            } else {
              postData.packageUrl = responseImage
              if (responseImage) {
                const filename = responseImage?.split('/').pop().split('.')[0];
                postData.meisheUuid = filename;
              } else {
                postData.meisheUuid = postData.uuid
              }
              postData.cover = bannerImage
              postData.name = assetInfoJson?.name
              postData.previewVideo = previewUrl
              console.log(postData)
              callAPI(postData)
            }

          }
        })
      } catch (error) {
        console.error('Error reading zip file:', error)
        dispatch(uplodateLoading(false))
      }
    } else {
      showDangerToast('Please upload Resource or Banner')
      dispatch(uplodateLoading(false))
    }
  }

  useEffect(() => {
    props.setThumbanailControl({
      showError: false,
      errorMessage: '',
      showImage: true,
      imageData: { src: props?.bannerFormData?.imageUrl }
    })
    props.setFilterFileControl({
      showError: false,
      errorMessage: '',
      showImage: true,
      imageData: { src: props?.bannerFormData?.imageUrl }
    })
  }, [props?.show === true])

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          {props?.bannerFormData?.id ? 'Update Meishe Asset' : 'Add Meishe Asset'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row'>
          <div className='col-md-6'>
            <h4>Display Name</h4>
            <Form.Control
              value={assetInfoJson?.name}
              onChange={e =>
                setAssetInfoJson({
                  ...assetInfoJson,
                  name: e.target.value
                })
              }
              placeholder='Display Name'
              aria-label='Small'
              aria-describedby='inputGroup-sizing-sm'
            />
            {!assetInfoJson?.name && isSubmitted ? (
              <label className='custom-error-label'>Name is required*</label>
            ) : (
              <></>
            )}
          </div>
          <div className='col-md-6'>
            <h4>Resource</h4>
            <input
              type='file'
              accept='.zip,.rar,.7zip'
              onChange={handleOnFileSelect}
            />
            {!meisheAssetFile && isSubmitted ? (
              <label className='custom-error-label'>
                Resource is required*
              </label>
            ) : (
              <></>
            )}
          </div>
          {meisheAssetFile && !imageFile ? <div className='col-md-6'>
            <h4>Display Banner</h4>
            <input
              type='file'
              accept='image/png, image/gif, image/jpeg'
              onChange={handleOnFileBannerSelect}
            />
            {!bannerFile && isSubmitted ? (
              <label className='custom-error-label'>Banner is required*</label>
            ) : (
              <></>
            )}
          </div> : <></>}

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outlined' onClick={props.onHide}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  )
}
